export const GET_RANKING_FRAMES = "GET_RANKING_FRAMES";
export const CREATE_RANKING_FRAME = "CREATE_RANKING_FRAME";
export const UPDATE_RANKING_FRAME = "UPDATE_RANKING_FRAME";
export const DELETE_RANKING_FRAME = "DELETE_RANKING_FRAME";

export const OPEN_DIALOGUE_RANKING_FRAME = "OPEN_DIALOGUE_RANKING_FRAME";
export const CLOSE_DIALOGUE_RANKING_FRAME = "CLOSE_DIALOGUE_RANKING_FRAME";
